
import { StatusDecorator ,targetAppDecorator, targetWorkflowDecorator } from './StatusDecorator';
import {
  dateValueFormatterWithHHMM,
  dateTimeComparatorAgGrid,
  valueFormatterAgGrid,
  } from '../../utils';
import { CustomStatusRenderer } from '../../renderer';
import {CustomReleaseDeleteRenderer} from './CustomDeleteRenderer';
import { Button, BUTTON_VARIANTS, IconContentCopy } from 'cdk-radial';

export const defaultColDef = {
    enablePivot: true,
    sortable: true,
    filter: true,
    flex: 1,
    autoHeight: true,
    minWidth: 100,
    resizable: true,
    refreshCells: true,
    headerHeight: '150px',
};

export const excelConfig = {
    excelStyles: [
        {
            id: 'header',
            font: {
                bold: true,
                size: 15,
            },
            interior: {
                color: '#bbb4bb',
                pattern: 'Solid',
            },
        },
    ],
    fileName: 'Feature_Release_' + new Date().toJSON().slice(0, 10),
    allColumns: true,
    processCellCallback: function ({ column, value }: any) {
        return StatusDecorator(column.colId, value);
    },
};

export const getColumnDefs = (permissions: any,applications:any,workflows:any,archiveSwitch:any, t: Function) => {
    let columnDefinition = [
      {
        field: 'title',
        headerName: t('featureRelease.colTitle'),
        cellClass: 'formattedColumn',
      },
      {
        field: 'target.application',
        headerName: t('featureRelease.colTargetApps'),
        cellClass: 'formattedColumn',
        cellRenderer: (params: any) =>
        targetAppDecorator(params.data.target.application,applications),
      },
      {
        field: 'target.workflow',
        headerName: t('featureRelease.colTargetWorkflows'),
        cellClass: 'formattedColumn',
        cellRenderer: (params: any) =>
        targetWorkflowDecorator(params.data.target.workflow,workflows),
      },
      {
        field: 'target.enterpriseIds',
        headerName: t('featureRelease.colTargetEnterprises'),
        cellClass: 'formattedColumn',
      },
      {
        cellRenderer: (params: any) =>
          dateValueFormatterWithHHMM(params.data.createdDate),
        cellClass: 'formattedColumn',
        field: 'createdDate',
        headerName: t('featureRelease.colCreatedDateTime'),
        sortable: true,
        filterParams: {
          comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
          valueFormatter: (params: any) => valueFormatterAgGrid(params),
        },
      },
      {
        field: 'createdBy',
        headerName: t('featureRelease.colCreatedBy'),
        cellClass: 'formattedColumn',
      },
      {
        cellRenderer: (params: any) =>
          dateValueFormatterWithHHMM(params.data.lastUpdatedDate),
        cellClass: 'formattedColumn',
        field: 'lastUpdatedDate',
        headerName: t('featureRelease.colUpdatedDateTime'),
        sortable: true,
        filterParams: {
          comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
          valueFormatter: (params: any) => valueFormatterAgGrid(params),
        },
      },
      {
        field: 'lastUpdatedBy',
        headerName: t('featureRelease.colUpdatedBy'),
        cellClass: 'formattedColumn',
      },
      {
        cellRenderer: (params: any) =>
          dateValueFormatterWithHHMM(params.data.startDate),
        field: 'startDate',
        headerName: t('featureRelease.colStartDateTime'),
        sortable: true,
        cellClass: 'formattedColumn',
        filterParams: {
          comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
          valueFormatter: (params: any) => valueFormatterAgGrid(params),
        },
      },
      {
        cellRenderer: (params: any) =>
          dateValueFormatterWithHHMM(params.data.endDate),
        field: 'endDate',
        headerName: t('featureRelease.colEndDateTime'),
        sortable: true,
        cellClass: 'formattedColumn',
        filterParams: {
          comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
          valueFormatter: (params: any) => valueFormatterAgGrid(params),
        },
      },
      {
        field: 'active',
        cellRenderer: (params: any) => (
          <CustomStatusRenderer isActive={params.data.active} startDate={params.data.startDate}/>
        ),
        headerName: 'Status',
        sortable: true,
        colId: 'Status',
      },
      {
        colId: 'Delete',
        cellRenderer: (params: any) => <CustomReleaseDeleteRenderer />,
        sortable: true,
        getQuickFilterText: (params: any) => {
          return '';
        },
      },
      
      {
        colId: 'Duplicate',
        cellRenderer: (params: any) => <Button
        title="Copy"
        icon={<IconContentCopy />}
        text="Duplicate"
        variant={BUTTON_VARIANTS.ICON}
        onClick={""}
      />,
        sortable: true
      },
      
    ];
  
    if (!permissions?.hasReleaseUpdatePermissions || archiveSwitch === true) {
      columnDefinition = columnDefinition.filter((col) => col.colId !== 'Delete');
    }

    if (archiveSwitch === true) {
      columnDefinition = columnDefinition.filter((col) => col.colId !== 'Status' && col.colId !== 'Duplicate');
    }
  
    return columnDefinition;
};
  